import { OrderReportingSalesDAO } from './OrderReportingSalesDAO';

export class OrderReportingSalesTaxationAllDAO extends OrderReportingSalesDAO {
  constructor() {
    super('ster_order_reporting_sales_taxation', 'order_id');
  }
}
